module.exports = __webpack_public_path__ + "static/media/icon_check_small.8d2e4ef2.svg";